
import React, { useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../services/authConfig";
import { callMsGraph } from "../../services/graph";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { Col, Container, Dropdown, NavLink, Row } from "react-bootstrap";

import './header.scss';
import { Outlet, Route, Routes } from "react-router-dom";

export const Header = (props) => {


    const isAuthenticated = useIsAuthenticated();
    
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);

    if (isAuthenticated && !graphData) {
      console.log("Getting graph data");
      instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0]
        })
        .then((response) => {
            callMsGraph(response.accessToken)
            .then(resp => setGraphData(resp));
        });
    }
  

    return (
        <>
      <Container fluid={true} className="text-white sticky-top">
        <Row className="bg-dark justify-content-start align-items-center">
          <Col>
            <img className="logo m-3" src="/logo-sign.png" alt="MTS Logo" width="201px" height="56px"/>
          </Col>

          <Col md="auto" className="text-end">
              <Outlet />
              <Routes>
                <Route index element={
                    !isAuthenticated ? 
                    <SignInButton /> : 
                    <Dropdown>
                        <Dropdown.Toggle className="link-white" as={NavLink}>{accounts[0].name}</Dropdown.Toggle>
                        <Dropdown.Menu className="bg-dark">
                        <SignOutButton />
                        </Dropdown.Menu>
                    </Dropdown>
                } />
                <Route path="/public" />
            </Routes>
          </Col>
        </Row>
    </Container>
        </>
    );
};

